export default "__VITE_ASSET__Bt8dF6jm__"